import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kolhapurtopunecabs() {



  const cardData =
  {
    keyword: 'Kolhapur to Pune Cabs',
    heading: 'Sai Trupti Cabs: Kolhapur to Pune Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Kolhapur cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Kolhapur. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Kolhapur convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as Pune’s most powerful symbol of Maratha grandeur and pride. Built in 1732 by Peshwa Bajirao I, this majestic fort once served as the royal seat of the Peshwas. Its towering gates, ornate wooden architecture, and grand courtyards whisper stories of valor, politics, and betrayal. The Delhi Darwaza and Nagarkhana gateway are marvels of traditional design, while the evening light-and-sound show vividly recreates its glorious past. Despite surviving a devastating fire, the fort’s ruins continue to echo the strength of the Maratha Empire. Walking through Shaniwar Wada feels like stepping into Pune’s heroic history, where power and passion met within its ancient walls."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is one of Pune’s most beautiful and historically significant landmarks. Built in 1892 by Sultan Aga Khan III, this elegant Italian-style palace became an important site during India’s freedom movement. Mahatma Gandhi, Kasturba Gandhi, and Sarojini Naidu were imprisoned here during the Quit India Movement. The palace now houses a memorial museum displaying photographs, personal items, and letters from that period. Sprawling green lawns and calm corridors add a peaceful aura to its solemn history. The marble samadhis of Mahatma Gandhi and Kasturba within the compound inspire deep reverence. Visiting Aga Khan Palace connects every traveler to India’s legacy of sacrifice, peace, and independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched dramatically atop the Sahyadri Mountains, Sinhagad Fort is both a trekker’s paradise and a monument of courage. The fort witnessed the legendary battle where Tanaji Malusare fought valiantly for Chhatrapati Shivaji Maharaj, earning eternal glory. A winding 3-km climb leads you to breathtaking valley views and winds that hum ancient songs of bravery. The fort walls, watchtowers, and remnants of royal bastions stand proudly against time. Local vendors serve piping hot pithla-bhakri and lemon water at the top, making the experience rustic and rewarding. Sinhagad isn’t just a fort — it’s Pune’s living tribute to Maratha valor, perseverance, and pride."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises serenely above Pune city, offering both divine peace and panoramic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas in the 18th century. The climb of 108 stone steps is considered auspicious, and the reward is a breathtaking 360-degree view of the city skyline. The site also houses small temples of Vishnu, Kartikeya, and Rama, along with the Parvati Museum showcasing Peshwa artifacts. Early mornings fill the air with chants and bells, while evenings glow with golden sunsets. Parvati Hill is where faith and nature coexist in perfect harmony above the bustling city below."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s beating spiritual heart — a temple that embodies devotion, discipline, and community. The dazzling idol of Lord Ganesha, adorned with gold and intricate decorations, attracts devotees from all over India. Established more than a century ago, the temple is not only a place of worship but also a center of philanthropy, funding schools, orphanages, and hospitals. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and countless prayers. Whether you are seeking blessings or peace, Dagdusheth Temple radiates an aura of divine energy that fills every visitor with calm and faith."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a hidden gem that takes you through 3,000 years of Indian art, craft, and culture. Founded by Dr. Dinkar Kelkar, it houses over 20,000 artifacts, including musical instruments, ancient weapons, ornaments, paintings, and household objects. The most fascinating feature is the reconstructed 'Mastani Mahal,' reminiscent of Peshwa Bajirao’s legendary love story. Each exhibit tells a story — of craftsmanship, daily life, and forgotten traditions. The museum’s narrow corridors and antique fragrance transport visitors into another era. It’s not just a museum but a living tribute to India’s artistic soul preserved with passion and precision."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Located just 20 km from Pune, Khadakwasla Dam is the city’s favorite evening and weekend retreat. Built across the Mutha River, it supplies water to the city while offering stunning scenic views. The calm waters reflect the changing sky, especially during sunset when hues of orange and pink paint the landscape. During monsoon, the area turns into a lush green paradise with overflowing waters and cool breezes. Locals love to snack on spicy bhajis and corn cobs from roadside stalls while enjoying the view. Khadakwasla isn’t just a dam — it’s Pune’s natural escape, where nature refreshes both body and spirit."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is one of the most tranquil and modern spiritual retreats in the world. Spread across 28 acres of landscaped gardens, bamboo groves, and reflective pools, it offers meditation, yoga, and wellness programs for seekers of peace. The resort’s Zen-style architecture and quiet pathways create a space for introspection and balance. Visitors from over 100 countries come here to meditate and rejuvenate in an atmosphere of freedom and acceptance. Whether you spend a day or a week, Osho Ashram transforms inner calm into a beautiful reality amidst Pune’s urban pulse."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, also known as Pu La Deshpande Udyan, is a symbol of peace and cultural harmony. Inspired by Japan’s famous Korakuen Garden, it spreads across 10 acres of lush lawns, streams, and bridges. Named after the celebrated Marathi writer Pu La Deshpande, the garden combines Japanese design precision with Indian greenery. The flowing water channels, stone lanterns, and cherry-blossom-like trees create an ambience of serenity. Families, photographers, and joggers all find solace here. It’s a place where nature’s poetry blooms in every petal and where Pune’s love for art and nature gracefully meet."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Nestled quietly in the heart of Pune, the Pataleshwar Cave Temple is an 8th-century marvel carved from a single basalt rock. Dedicated to Lord Shiva, it features massive stone pillars, circular Nandi mandapa, and intricate carvings that have withstood the test of time. The dim interiors and echoing chants create an aura of deep spirituality. Believed to have been built by the Rashtrakutas, it remains one of Pune’s oldest surviving monuments. Amidst the city’s modern chaos, Pataleshwar Temple offers peace, history, and a timeless reminder of Pune’s ancient roots and enduring faith."
  }
],



"services": [
  {
    "name": "Kolhapur to Pune Cabs",
    "description": "Book comfortable Kolhapur to Pune cabs with reliable service, AC/non-AC options, experienced drivers, and flexible pickup/drop points. Perfect for family trips, weekend getaways, or group travel with affordable fares and easy online booking."
  },
  {
    "name": "Kolhapur to Pune Taxi Service",
    "description": "Hire a taxi from Kolhapur to Pune for a smooth, scenic ride. Enjoy well-maintained vehicles, courteous chauffeurs, flexible timings, and transparent pricing for one-way or round-trip travel."
  },
  {
    "name": "Kolhapur to Pune Car Hire",
    "description": "Rent a car from Kolhapur to Pune for comfortable and personalized travel. Choose from Sedans, SUVs, and luxury cars with AC/non-AC options, professional drivers, luggage assistance, and flexible route options."
  },
  {
    "name": "AC Cab Kolhapur to Pune",
    "description": "Travel comfortably with AC cab service from Kolhapur to Pune. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickups, and safe travel — ideal for families, couples, and tourists."
  },
  {
    "name": "Non AC Cab Kolhapur to Pune",
    "description": "Affordable non-AC cab service from Kolhapur to Pune with reliable drivers, well-maintained cars, and flexible pickup/drop points. Perfect for travelers looking for budget-friendly rides."
  },
  {
    "name": "Innova Cab Kolhapur to Pune",
    "description": "Spacious and comfortable Innova cabs for Kolhapur to Pune trips. Perfect for families or groups, featuring AC comfort, ample legroom, experienced drivers, and smooth travel for a relaxing journey."
  },
  {
    "name": "Ertiga Cab Kolhapur to Pune",
    "description": "Book an Ertiga cab from Kolhapur to Pune for affordable group travel. Enjoy AC/non-AC options, comfortable seating, luggage space, and experienced drivers who ensure a safe and enjoyable ride."
  },
  {
    "name": "Luxury Cab Kolhapur to Pune",
    "description": "Travel in style with luxury cab service from Kolhapur to Pune featuring premium Sedans and SUVs. Ideal for VIP guests, corporate executives, or honeymoon trips — offering luxury interiors, AC service, and professional chauffeurs."
  },
  {
    "name": "Affordable Cab Kolhapur to Pune",
    "description": "Get pocket-friendly Kolhapur to Pune cab services with transparent fares, AC/non-AC options, professional drivers, flexible timings, and easy booking. Perfect for solo travelers, students, and small families."
  },
  {
    "name": "Kolhapur to Pune Outstation Cab",
    "description": "Reliable outstation cab service from Kolhapur to Pune ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible booking, and safe travel with experienced drivers."
  },
  {
    "name": "Kolhapur to Pune One Way Cab",
    "description": "Book one-way cabs from Kolhapur to Pune at affordable rates. Enjoy point-to-point travel, clean vehicles, professional drivers, and flexible pickup options — perfect for travelers without return plans."
  },
  {
    "name": "Kolhapur to Pune Drop Cab",
    "description": "One-way drop cab service from Kolhapur to Pune with flexible timings, AC/non-AC options, professional drivers, and smooth travel experience. Best for travelers looking for comfortable one-time transfers."
  },
  {
    "name": "Corporate Cab Kolhapur to Pune",
    "description": "Premium corporate cab hire from Kolhapur to Pune offering executive vehicles, professional chauffeurs, flexible travel schedules, and business-class comfort. Ideal for conferences, retreats, and client visits."
  },
  {
    "name": "Wedding Cab Kolhapur to Pune",
    "description": "Hire elegant wedding cabs from Kolhapur to Pune with luxury interiors, AC comfort, professional chauffeurs, and on-time pickups. Perfect for bride/groom transfers, guests, or event logistics with complete reliability."
  },
  {
    "name": "Online Cab Booking Kolhapur to Pune",
    "description": "Book your Kolhapur to Pune cab online with instant confirmation, secure payment options, and transparent fares. Choose from Sedans, Ertigas, and Innovas for a convenient and stress-free ride."
  }
],
"tableData": [
  ["Kolhapur to Pune Cabs", "Kolhapur to Pune Taxi Service"],
  ["Kolhapur to Pune Car Hire", "AC Cab Kolhapur to Pune"],
  ["Non AC Cab Kolhapur to Pune", "Innova Cab Kolhapur to Pune"],
  ["Ertiga Cab Kolhapur to Pune", "Luxury Cab Kolhapur to Pune"],
  ["Affordable Cab Kolhapur to Pune", "Kolhapur to Pune Outstation Cab"],
  ["Kolhapur to Pune One Way Cab", "Kolhapur to Pune Drop Cab"],
  ["Online Cab Booking Kolhapur to Pune", "Corporate Cab Kolhapur to Pune"],
  ["Wedding Cab Kolhapur to Pune", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Kolhapur to Pune Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable cab services from Kolhapur to Pune — ideal for business travel, family trips, and convenient city transfers."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy clear and affordable one-way fares for Kolhapur to Pune cabs with no hidden charges, ensuring complete transparency and value for money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from a variety of vehicles — hatchbacks, sedans, SUVs, or premium cars — to match your comfort, group size, and travel preferences."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained and courteous drivers are well-versed with the Kolhapur to Pune route, providing a safe, smooth, and punctual travel experience."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "Get picked up from anywhere in Kolhapur — whether it’s your home, hotel, or office — and dropped off at your preferred Pune destination, including the airport."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Every Sai Trupti cab is regularly serviced, sanitized, and maintained to offer you a clean and comfortable journey."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our customer support team is available around the clock to assist with bookings, travel queries, or route guidance for your Kolhapur–Pune trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Kolhapur to Pune cab easily through a quick call, WhatsApp, or our website — get instant confirmation and on-time vehicle dispatch."
  }
]





















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Kolhapur to Pune cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and comfortable Kolhapur to Pune cab services for one way, round trips, and business or personal travel needs.',
  },
  {
    question: 'How can I book a Kolhapur to Pune cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Kolhapur to Pune cab through our website, mobile app, or by calling our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Kolhapur to Pune?',
    answer: 'We offer a wide range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers suitable for families, groups, and corporate travelers.',
  },
  {
    question: 'Are Sai Trupti Cabs drivers experienced for Kolhapur to Pune routes?',
    answer: 'Absolutely. All our drivers are skilled, professional, and familiar with the Kolhapur–Pune highway routes to ensure a smooth and safe journey.',
  },
  {
    question: 'Can I book a cab for local travel or return trip from Pune to Kolhapur?',
    answer: 'Yes, we offer both one-way and round-trip cab services. You can also book local Pune sightseeing or return trips conveniently with Sai Trupti Cabs.',
  },
  {
    question: 'Is the Kolhapur to Pune cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Kolhapur to Pune cab services so you can travel at your convenience, anytime—day or night.',
  },
  {
    question: 'What are the Kolhapur to Pune cab fares?',
    answer: 'Our Kolhapur to Pune cab fares start from ₹2,800 for sedans and ₹3,800–₹4,800 for SUVs or Innova Crysta, depending on your trip type and vehicle preference.',
  },
  {
    question: 'What payment options are available for Kolhapur to Pune cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, and bank transfers to make your booking process quick and hassle-free.',
  },
  {
    question: 'What safety measures are followed for Kolhapur to Pune cabs?',
    answer: 'All vehicles are thoroughly sanitized before each trip, and our drivers follow strict hygiene and safety protocols for your peace of mind.',
  },
  {
    question: 'Is customer support available during the Kolhapur to Pune cab journey?',
    answer: 'Yes, our 24×7 customer support team is always available to assist you throughout your Kolhapur to Pune trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sagar Patil',
    feedback: 'Had a great experience with Sai Trupti Cabs for our Kolhapur to Pune trip. The driver was punctual and very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anjali Kulkarni',
    feedback: 'Smooth and comfortable ride from Kolhapur to Pune. The car was clean, and the driver was polite and safe. Highly recommend Sai Trupti Cabs!',
    rating: 5,
  },
];





















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Kolhapur to Pune Cab Service",
  "image": "https://saitrupticabs.com/assets/images/kolhapur-to-pune-cab.jpg",
  "description": "Sai Trupti Cabs provides reliable Kolhapur to Pune cab service with one way taxi, round trip cabs, Innova Crysta, Ertiga, sedan and SUV options. Book affordable outstation cabs with professional drivers, 24x7 availability and safe travel experience.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Kolhapur to Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7320"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2799",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/kolhapur-to-pune-cab-booking",
    "itemCondition": "https://schema.org/NewCondition"
  }
};





  return (
    <div>

<Helmet>
  <title>Kolhapur to Pune Cab Service | One Way Taxi ₹2799 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Kolhapur to Pune cab at best price ₹2799 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, affordable and 24x7 cab service with experienced drivers." 
  />

  <meta 
    name="keywords" 
    content="kolhapur to pune cab, kolhapur to pune taxi, kolhapur to pune cab service, kolhapur to pune one way cab, kolhapur to pune taxi fare, kolhapur to pune innova crysta, kolhapur to pune ertiga cab, kolhapur to pune sedan cab, cheap kolhapur to pune cab, best cab service kolhapur to pune, kolhapur to pune drop taxi, kolhapur to pune round trip cab, outstation cab kolhapur to pune, kolhapur to pune online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/67.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kolhapurtopunecabs;